import { Injectable } from '@angular/core';
import { Route, RouteTitlesProviderService } from '@web/common';

@Injectable()
export class AppRouteTitlesProviderService extends RouteTitlesProviderService {
  public override titles(): Map<Route, string> {
    /* prettier-ignore */
    return new Map([
      [Route.Loading, 'Ładowanie'],
      [Route.NotFound, 'Nie znaleziono strony'],
      [Route.PL_Account, 'Mój profil'],
      [Route.PL_AccountAddresses, 'Adresy'],
      [Route.PL_AccountDetails, 'Szczegóły konta'],
      [Route.PL_AccountOrderDetails, 'Szczegóły zamówienia'],
      [Route.PL_AccountOrders, 'Zamówienia'],
      [Route.PL_AccountQuestionnaireDetails, 'Ankieta'],
      [Route.PL_AccountQuestionnaires, 'Ankiety'],
      [Route.PL_AccountSubscriptionDetails, 'Szczegóły subskrypcji'],
      [Route.PL_AccountSubscriptions, 'Subskrypcje'],
      [Route.PL_AccountBeautyProfile, 'Profil piękności'],
      [Route.PL_BoxDetails, 'Box'],
      [Route.PL_BoxDetailsAuthorization, 'Box zabezpieczony hasłem'],
      [Route.PL_Boxes, 'Nasze edycje'],
      [Route.PL_Brands, 'Nasze marki'],
      [Route.PL_Checkout, 'Dostawa i płatność'],
      [Route.PL_Contact, 'Kontakt'],
      [Route.PL_CosmeticDetails, 'Szczegóły kosmetyku'],
      [Route.PL_FAQ, 'Najczęściej zadawane pytania'],
      [Route.PL_OrderBox, 'Zamów box'],
      [Route.PL_OrderPaymentRedirection, 'Przekierowanie płatności'],
      [Route.PL_OrderSummaryWithToken, 'Podsumowanie zamówienia'],
      [Route.PL_Payment, 'Płatność'],
      [Route.PL_PrivacyPolicy, 'Polityka prywatności'],
      [Route.PL_ProductDetails, 'Szczegóły produktu'],
      [Route.PL_Products, 'Produkty'],
      [Route.PL_ProductDetailsAuthorization, 'Product zabezpieczony hasłem'],
      [Route.PL_RegulationsOfPublishingOpinions, 'Regulamin publikowania opinii'],
      [Route.PL_RegulationsOfShop, 'Regulamin sklepu'],
      [Route.PL_ShoppingCartDetails, 'Koszyk'],
      [Route.Root, 'Box z kosmetykami dla Ciebie'],
      [Route.SignIn, 'Logowanie'],
      [Route.SignOut, 'Rejestracja'],
    ]);
  }
}
